<template>
    <div spellcheck="false">
        <v-layout v-if="showLabel && (!checkExistSettings || isEditable)">
            <div class="param-key label mr-6">{{ keyLabel | capitalize }}</div>
            <div class="label">{{ valueLabel | capitalize }}</div>
        </v-layout>
        <div
            v-if="!isEditable && checkExistSettings"
            style="font-family: 'open sans',serif; font-size: 14px; color: #727885"
        >
            {{ $f.tc('noDataAvailable') }}
        </div>
        <!--truong hop la card setting-->
        <div v-if="nodeSettingVariableList">
            <v-layout
                v-for="(item, idx) in itemList.filter(i => !keysIgnored.includes(i.key))"
                :key="idx"
                align-center
                :style="{marginTop: idx !== 0 ? '8px' : '3px'}"
            >
                <template v-if="!keysIgnored.includes(item.key)">
                    <div style="width: 155px">
                        <v-combobox
                            hide-details
                            v-if="nodeSettingVariableList"
                            :items="nodeSettingVariableList.map(i => i.variable)"
                            v-model="item.key"
                            class="input-custom mr-6"
                            :readonly="!editable" @input="mapVariableDefaultValue(item.key)"
                        ></v-combobox>
                        <v-combobox v-model="item.key" class="input-custom mr-6" v-else
                                    :editable="editable"></v-combobox>
                    </div>
                    <ScenarioInput v-model="item.value" class="param-value" ref="ScenarioInput"
                                   :readonly="!editable"></ScenarioInput>
                    <div class="btn-icon-2 ml-6" v-if="editable">
                        <img
                            src="/img/scenario/delete-new_red.svg"
                            alt="icon-delete"
                            style="width: 18px"
                            @click="removeItem(idx)"
                        >
                    </div>
                </template>
            </v-layout>
        </div>
        <!--truong hop la card khac-->
        <div v-else>
            <v-layout align-center v-for="(item, idx) in itemList" :key="idx"
                      :style="{marginTop: idx !== 0 ? '8px' : '3px'}">
                <template v-if="!keysIgnored.includes(item.key)">
                    <ScenarioSelect v-if="keyList" :items="keyList" v-model="item.key" class="param-key mr-6"
                                    :editable="editable"></ScenarioSelect>
                    <ScenarioInput v-model="item.key" class="param-key mr-6" v-else
                                   :editable="editable"></ScenarioInput>
                    <ScenarioInput v-model="item.value" class="param-value" ref="ScenarioInput"
                                   :editable="editable"></ScenarioInput>
                    <div class="btn-icon-2 ml-6" v-if="editable">
                        <img
                            src="/img/scenario/delete-new_red.svg"
                            alt="icon-delete"
                            style="width: 18px;"
                            @click="removeItem(idx)"
                        >
                    </div>
                </template>
            </v-layout>
        </div>
        <v-layout align-center v-if="isEditable" class="mt-8">
            <ScenarioSelect
                v-model="key"
                class="param-key mr-6"
                ref="KeyEditor"
                :items="keyList"
                v-if="keyList"
            ></ScenarioSelect>
            <!--truong hop la card setting-->
            <div class="mr-6" v-if="nodeSettingVariableList" style="width: 149px">
                <v-combobox
                    hide-details
                    v-model="key"
                    class="input-custom"
                    ref="KeyCombobox"
                    :items="nodeSettingVariableList.map(item => item.variable)"
                    @input="mapVariableDefaultValue(key)"
                ></v-combobox>
            </div>
            <ScenarioInput
                v-else
                v-model="key"
                class="param-key mr-6"
                @enter="addItem"
                ref="KeyEditor"
                :editable="editable"
            ></ScenarioInput>
            <ScenarioInput v-model="value" class="param-value" @enter="addItem" ref="ValueEditor"></ScenarioInput>
            <div class="btn-icon-2 ml-6" v-if="allowAddItem">
                <img src="/img/scenario/add_grey.svg" alt="icon-add" style="width: 16px;" @click="addItem">
            </div>
        </v-layout>
        <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
    </div>
</template>

<script>
import ScenarioInput from "@/views/Scenario/components/ScenarioInput";
import ScenarioSelect from "@/views/Scenario/components/ScenarioSelect";
import ScenarioService from "@/services/scenario.service";
import lodash from "lodash";

export default {
    name: "SettingEditor",
    components: {ScenarioSelect, ScenarioInput},
    props: {
        items: {
            type: [Object, Array]
        },
        dataFormat: { // format for items
            type: String,
            default: 'object'
        },
        keyLabel: {
            type: String,
            default: "Key"
        },
        valueLabel: {
            type: String,
            default: "Value"
        },
        showLabel: {
            type: Boolean,
            default: true
        },
        editable: {
            type: Boolean,
            default: true
        },
        keyList: Array,
        allowAddItem: {
            type: Boolean,
            default: true
        },
        nodeSettingVariableList: Array,
        invalidKey: {
            type: Array,
            default: () => []
        },
        keysIgnored: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            itemList: [],
            key: '',
            value: '',
            errorMessage: '',
            listener: null
        }
    },
    computed: {
        isEditable() {
            if (typeof this.editable === 'boolean') {
                return this.editable
            }
            return ScenarioService.isEditable() && ScenarioService.isModeEditing()
        },
        checkExistSettings() {
            return this.itemList.filter(i => !this.keysIgnored.includes(i.key)).length === 0
        },
    },
    methods: {
        mapVariableDefaultValue(key) {
            if (this.nodeSettingVariableList) {
                let object = this.nodeSettingVariableList.reduce(
                    (obj, item) => Object.assign(obj, {[item.variable]: item.default_value}), {});
                this.value = object[key]
            }
        },
        removeItem(index) {
            this.itemList.splice(index, 1)
        },
        addItem() {
            this.checkLastItem()
            if (this.invalidKey.length > 0 && this.invalidKey.includes(this.key)) {
                this.errorMessage = `${this.key} field not allowed`
            }

            if (this.errorMessage) {
                return
            }

            this.itemList.push({
                key: this.key.trim(),
                value: this.value
            })
            if (this.$refs.KeyEditor) {
                this.$refs.KeyEditor.clear()
                this.$refs.KeyEditor.$el.focus()
            }

            if (this.$refs.KeyCombobox) {
                this.$refs.KeyCombobox.reset()
            }

            this.$refs.ValueEditor.clear()
        },
        checkLastItem() {
            if (this.key) {
                let item = this.itemList.find(item => item.key === this.key)
                if (item) {
                    this.errorMessage = `key duplicate - ${this.key}`
                } else {
                    this.errorMessage = ''
                }
            } else {
                this.errorMessage = (this.$f.tc(this.keyLabel) || 'Key') + ' field is required'
            }
        },
    },
    watch: {
        items: {
            immediate: true,
            handler: function (newItems) {
                if (!newItems) {
                    this.itemList = []
                    return
                }
                if (Array.isArray(newItems)) {
                    this.itemList = newItems
                    return
                }

                let list = []
                Object.keys(newItems).forEach(key => {
                    list.push({
                        key: key.trim(),
                        value: newItems[key]
                    })
                })
                this.itemList = list
            }
        },
        itemList: {
            deep: true,
            handler(newItemList) {
                let newSettings = newItemList
                newSettings = {}
                newItemList.forEach(item => {
                    newSettings[item.key] = item.value
                })

                if (!lodash.isEqual(newSettings, this.items)) {
                    this.$emit('update:items', newSettings)
                    this.$emit('save')
                }
            }
        }
    }
}
</script>

<style scoped lang="scss">
.param-key {
    width: 149px;
}

.param-value {
    flex-grow: 1;
}

.error-message {
    color: red;
    margin-top: 5px;
    font-size: 13px;
    font-family: "open sans", serif;
}

img {
    width: 16px;
    flex-shrink: 0;
    cursor: pointer;
}

.label {
    font-family: "open sans semi", serif !important;
    font-size: 13px;
    margin-bottom: 0 !important;
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;

            &:before, &:after {
                border: none !important;
            }
        }

        .v-label {
            background: #FFFFFF !important;
            padding: 0 6px;

            &:not(.v-label--active) {
                font-size: 14px !important;
                padding-left: 0 !important;
            }
        }
    }

    &.v-select {
        ::v-deep {
            .v-input__slot {
                padding: 0 6px 0 12px !important;
            }
        }
    }
}

::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }
}
</style>
